import { DraggableItem, DraggableItemNumber } from "../../pages/setting/pages/optionGroup/components/catalogOption/components/draggableItem/types";
import { DropDownLink } from "../../pages/setting/pages/optionGroup/components/catalogOption/typpes";


const generateId = (): number => {
    //const timestamp = Date.now();
    //const random = Math.floor(Math.random() * 10000);
    const random = Date.now() + Math.floor(Math.random() * 1000);
    return random;
};

const normalizeIds = (items: DraggableItem[]): DraggableItemNumber[] => {
    let counter = 1;
    
    const processNode = (node: DraggableItem): DraggableItemNumber => {

        const newId = counter;
        counter++;

        return {
            ...node,
            id: newId,
            children: node.children?.map(processNode) ?? [],
        };
    };

    return items.map(processNode);
};

const formatDropDownLinks = (node: DraggableItemNumber, parent?: DraggableItemNumber): DropDownLink[] => {
    let links: DropDownLink[] = [];

    node.children.forEach((child, i) => {
        const parentEditable = parent?.isEditable ?? false;
        const currentEditable = node.isEditable;
        const childEditable = child.isEditable;

        const link: DropDownLink = {
            parent_drop_down_id: null,
            parent_drop_down: undefined,
            current_drop_down_id: null,
            current_drop_down: undefined,
            next_drop_down_id: null,
            next_drop_down: undefined,
            current_node: node.id,
            next_node: child.id,
            required_text: node.textInput ?? false,
        };

        // === CASOS SEGÚN COMBINACIONES ===
        // Caso 1: Padre texto / Item texto / Hijo texto
        if (parentEditable && currentEditable && childEditable) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
            link.next_drop_down_id = null;
            link.next_drop_down = child.label;
        }

        // Caso 2: Padre texto / Item texto / Hijo catálogo
        else if (parentEditable && currentEditable && !childEditable) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
            link.next_drop_down_id = child.itemSubCatalogId ?? null;
            link.next_drop_down = undefined;
        }

        // Caso 3: Padre texto / Item catálogo / Hijo catálogo
        else if (parentEditable && !currentEditable && !childEditable) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
            link.next_drop_down_id = child.itemSubCatalogId ?? null;
            link.next_drop_down = undefined;
        }

        // Caso 4: Padre catálogo / Item catálogo / Hijo catálogo
        else if (!parentEditable && !currentEditable && !childEditable) {
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
            link.next_drop_down_id = child.itemSubCatalogId ?? null;
            link.next_drop_down = undefined;
        }

        // Caso 5: Padre catálogo / Item texto / Hijo texto
        else if (!parentEditable && currentEditable && childEditable) {
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
            link.next_drop_down_id = null;
            link.next_drop_down = child.label;
        }

        // Caso 6: Padre catálogo / Item catálogo / Hijo texto
        else if (!parentEditable && !currentEditable && childEditable) {
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
            link.next_drop_down_id = null;
            link.next_drop_down = child.label;
        }

        // Caso 7: Padre texto / Item catálogo / Hijo texto
        else if (parentEditable && !currentEditable && childEditable) {
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label ?? '';
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
            link.next_drop_down_id = null;
            link.next_drop_down = child.label;
        }

        // Caso 8: Padre catálogo / Item texto / Hijo catálogo
        else if (!parentEditable && currentEditable && !childEditable) {
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
            link.next_drop_down_id = child.itemSubCatalogId ?? null;
            link.next_drop_down = undefined;
        }

        links.push(link);
        links = links.concat(formatDropDownLinks(child, node)); // recursión
    });

    // === CASO FINAL: NODO SIN HIJOS ===
    if (node.children.length === 0 /* && parent */) {
        const parentEditable = parent?.isEditable ?? false;
        const currentEditable = node.isEditable;

        const link: DropDownLink = {
            parent_drop_down_id: null,
            parent_drop_down: undefined,
            current_drop_down_id: null,
            current_drop_down: undefined,
            next_drop_down_id: null,
            next_drop_down: undefined,
            current_node: node.id,
            next_node: null,
            required_text: node.textInput ?? false,
        };

        //Mismas reglas pero sin next_*
        if (parentEditable && currentEditable) {
            // Caso 1 sin hijo (texto / texto)
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
        } else if (parentEditable && !currentEditable) {
            // Caso 3 o 7 (texto / catálogo)
            link.parent_drop_down_id = null;
            link.parent_drop_down = parent?.label;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
        } else if (!parentEditable && !currentEditable) {
            // Caso 4 o 6 (catálogo / catálogo)
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = node.itemSubCatalogId ?? null;
            link.current_drop_down = undefined;
        } else if (!parentEditable && currentEditable) {
            // Caso 5 u 8 (catálogo / texto)
            link.parent_drop_down_id = parent?.itemSubCatalogId ?? null;
            link.parent_drop_down = undefined;
            link.current_drop_down_id = null;
            link.current_drop_down = node.label;
        }

        links.push(link);
    }

    return links;
};

const createOptionDropDownBody = ({ items }: { items: DraggableItem[] }) => {

    const normalizedItems = normalizeIds(items);

    const drop_downs_links = normalizedItems.flatMap(child => formatDropDownLinks(child));


    const body = {
        drop_downs_links,
    }

    return body
}


export { createOptionDropDownBody }